export const CONFIRMATION = {
  LOAD_CONFIRMATION_START: 'CONFIRMATION_LOAD_START',
  LOAD_CONFIRMATION_START_DONE: 'CONFIRMATION_LOAD_START_DONE',
  LOAD_CONFIRMATION_START_FAILED: 'CONFIRMATION_LOAD_START_FAILED',
  LOAD_CONFIRMATION_FINISH: 'CONFIRMATION_LOAD_FINISH',
  LOAD_CONFIRMATION_FINISH_DONE: 'CONFIRMATION_LOAD_FINISH_DONE',
  LOAD_CONFIRMATION_FINISH_FAILED: 'CONFIRMATION_LOAD_FINISH_FAILED',
  SAVE_CONFIRMATION_START: 'CONFIRMATION_SAVE_START',
  SAVE_CONFIRMATION_START_DONE: 'CONFIRMATION_SAVE_START_DONE',
  SAVE_CONFIRMATION_START_FAILED: 'CONFIRMATION_SAVE_START_FAILED',
  SAVE_CONFIRMATION_FINISH: 'CONFIRMATION_SAVE_FINISH',
  SAVE_CONFIRMATION_FINISH_DONE: 'CONFIRMATION_SAVE_FINISH_DONE',
  SAVE_CONFIRMATION_FINISH_FAILED: 'CONFIRMATION_SAVE_FINISH_FAILED',
};

export const getStartConfirmation = id => ({ type: CONFIRMATION.LOAD_CONFIRMATION_START, id });
export const getFinishConfirmation = id => ({ type: CONFIRMATION.LOAD_CONFIRMATION_FINISH, id });
export const saveStartConfirmation = (id, newTab) => ({ type: CONFIRMATION.SAVE_CONFIRMATION_START, id, newTab });
export const saveFinishConfirmation = (id, newTab) => ({ type: CONFIRMATION.SAVE_CONFIRMATION_FINISH, id, newTab });



// WEBPACK FOOTER //
// ./src/actions/confirmation.js